// extracted by css-extract-rspack-plugin
var _1 = "QDzdp1FU4Z480BCT";
var _2 = "GjywY19HSUhScqtH";
var _3 = "hIq_ZTRs_ygJ2Or8";
export { _1 as "iconPosition", _2 as "iconPositionMobile", _3 as "iconPositionRight" }
